Property_screener = {
	init : function()
	{
		jQuery('#oc-screener-wrapper .screener-property-list').on('init', function(event, slick){
			jQuery('#oc-screener-wrapper .screener-property-list').addClass('initialised');
		});
		
		var duration = jQuery('#oc-screener-wrapper').attr('data-duration');
		if( !duration )
		{
			duration = 5000;
		}
		
		jQuery('#oc-screener-wrapper .screener-property-list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: duration,
			pauseOnHover: false
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	Property_screener.init();
	
});